import { ILegalEntityData } from '../../../components/organisms/LegalEntityDetails';
import { ILegalEntityExtendedAddress } from '../../../models/legalEntity';
import { IOrgLegalEntityData } from '../../../components/organisms/OrgLegalEntityDetails';

const missingFieldKeys = Object.freeze({
  primaryAddress: 'addLicence.missingFields.primaryAddress',
  primaryLicenceAuthority: 'addLicence.missingFields.primaryLicenceAuthority',
  mainPhoto: 'addLicence.missingFields.mainPhoto',
});

export const getMissingFieldsForIndividual = (
  legalEntity?: ILegalEntityData | null,
  addresses?: ILegalEntityExtendedAddress[],
  photo?: string | boolean | null,
): string[] => {
  const missingFields: string[] = [];

  if (addresses?.filter((addr) => addr.isDefault).length === 0)
    missingFields.push(missingFieldKeys.primaryAddress);

  if (!legalEntity?.primaryWeaponLicencingAuthorityUniqueId)
    missingFields.push(missingFieldKeys.primaryLicenceAuthority);

  if (!photo) missingFields.push(missingFieldKeys.mainPhoto);

  return missingFields;
};

export const getMissingFieldsForOrganisation = (
  legalEntity?: IOrgLegalEntityData | null,
  addresses?: ILegalEntityExtendedAddress[],
): string[] => {
  const missingFields: string[] = [];

  if (addresses?.filter((addr) => addr.isDefault).length === 0)
    missingFields.push(missingFieldKeys.primaryAddress);

  if (!legalEntity?.primaryWeaponLicencingAuthorityUniqueId)
    missingFields.push(missingFieldKeys.primaryLicenceAuthority);

  return missingFields;
};
